"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.keepMount = void 0;
let keepMount = store => {
    store.listen(() => { });
};
exports.keepMount = keepMount;
